import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  h1: {
    fontSize: 28,
    [theme.breakpoints.down('md')]: {
      fontSize: 22,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 22,
      }),
    },
  },
  h2: {
    [theme.breakpoints.down('lg')]: {
      fontSize: 18,
      marginBottom: theme.spacing(1),
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        fontSize: 18,
        marginBottom: theme.spacing(1),
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 16,
      }),
    },
  },
  titleSelect: {
    [theme.breakpoints.down('lg')]: {
      fontSize: 16,
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        fontSize: 16,
      }),
    },
  },
  approveButton: {
    marginLeft: 'auto',
    marginTop: theme.spacing(3.5),
    minWidth: 146,
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      minWidth: '100%',
    },
  },
  orderInfo: {
    marginBottom: theme.spacing(3.5),
  },
  select: {
    marginBottom: theme.spacing(3),
  },
  method: {
    [theme.breakpoints.down('md')]: {
      fontSize: 14,
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 14,
      }),
    },
  },
  status: {
    color: '#929A92',
    fontSize: 14,
    fontWeight: 600,
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(3.5),
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
      marginBottom: theme.spacing(2.5),
    },
    [theme.breakpoints.downLandscape('lg')]: {
      ...(theme.isMobileDevice && {
        marginBottom: theme.spacing(3.5),
      }),
    },
    [theme.breakpoints.downLandscape('md')]: {
      ...(theme.isMobileDevice && {
        fontSize: 12,
        marginBottom: theme.spacing(2.5),
      }),
    },
  },
}));
